import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* position: relative; */
`
export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top:20px;
  width:100%;
`
